import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import { db } from "../../firebase";
import "../HomeScreen.css";
import "./VisaServices.css";
import Navbar from "../Navbar";
import Footer from "../Footer";

const VisaServices = () => {
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    visaType: "Tourist Visa",
    destinationCountry: "",
    travelDate: "",
    applicants: "1",
    message: "",
  });
  const [status, setStatus] = useState(null); // null | "sending" | "success" | "error"

  const handleChange = (e) => {
    setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("sending");
    try {
      await addDoc(collection(db, "enquiry"), {
        ...form,
        enquiryType: "visa services",
        createdAt: serverTimestamp(),
      });

      setStatus("success");
      setForm({
        name: "",
        email: "",
        phone: "",
        visaType: "Tourist Visa",
        destinationCountry: "",
        travelDate: "",
        applicants: "1",
        message: "",
      });

      setTimeout(() => setStatus(null), 4000);
    } catch (err) {
      console.error("Error submitting visa enquiry: ", err);
      setStatus("error");
    }
  };

  return (
    <div className="home-container">
      <Navbar />

      {/* Hero Section */}
      <section 
        className="hero-section visa-hero"
        style={{ 
          background: "linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.6)), url('https://images.unsplash.com/photo-1500835556837-99ac94a94552?w=1600')",
          backgroundSize: "cover",
          backgroundPosition: "center"
        }}
      >
        <div className="hero-overlay">
          <h1>Hassle-Free <span style={{
              background: "linear-gradient(135deg, #ff8c00, #ff5500)",
              WebkitBackgroundClip: "text",
              backgroundClip: "text",
              color: "transparent"
            }}> VISA Services</span></h1>
          <p>We handle the paperwork, you pack your bags. Get expert guidance for a smooth approval.</p>
        </div>
      </section>

      {/* Visa Types Section */}
      <section className="visa-types-section">
        <div className="section-container">
          <h2 className="section-title-main">Visa Services</h2>
          <div className="visa-types-grid">
            <div className="visa-type-card">
              <div className="visa-type-icon">🏖️</div>
              <h3>Tourist Visa</h3>
              <p>Explore your dream destinations with our hassle-free tourist visa assistance.</p>
            </div>
            <div className="visa-type-card">
              <div className="visa-type-icon">💼</div>
              <h3>Business Visa</h3>
              <p>Fast-track your business trips with our expert business visa processing.</p>
            </div>
            <div className="visa-type-card">
              <div className="visa-type-icon">✈️</div>
              <h3>Transit Visa</h3>
              <p>Smooth transit solutions for your connecting international flights.</p>
            </div>
            <div className="visa-type-card">
              <div className="visa-type-icon">👨‍‍👧👦</div>
              <h3>Family/Dependent Visa</h3>
              <p>Reunite with your loved ones with our family visa support.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Popular Destinations Section */}
      <section className="visa-destinations-section">
        <div className="section-container">
          <h2 className="section-title-main">Popular Visa Destinations</h2>
          <div className="destinations-grid">
            <div className="destination-card">
              <div className="flag-container">
                <img src="https://flagcdn.com/w320/us.png" alt="United States" />
              </div>
              <h3>United States</h3>
            </div>
            <div className="destination-card">
              <div className="flag-container">
                <img src="https://flagcdn.com/w320/ca.png" alt="Canada" />
              </div>
              <h3>Canada</h3>
            </div>
            <div className="destination-card">
              <div className="flag-container">
                <img src="https://flagcdn.com/w320/gb.png" alt="United Kingdom" />
              </div>
              <h3>United Kingdom</h3>
            </div>
            <div className="destination-card">
              <div className="flag-container">
                <img src="https://flagcdn.com/w320/au.png" alt="Australia" />
              </div>
              <h3>Australia</h3>
            </div>
            <div className="destination-card">
              <div className="flag-container">
                <img src="https://flagcdn.com/w320/nz.png" alt="New Zealand" />
              </div>
              <h3>New Zealand</h3>
            </div>
            <div className="destination-card">
              <div className="flag-container">
                <img src="https://flagcdn.com/w320/sg.png" alt="Singapore" />
              </div>
              <h3>Singapore</h3>
            </div>
            <div className="destination-card">
              <div className="flag-container">
                <img src="https://flagcdn.com/w320/ae.png" alt="Dubai" />
              </div>
              <h3>Dubai (UAE)</h3>
            </div>
            <div className="destination-card">
              <div className="flag-container">
                <img src="https://flagcdn.com/w320/eu.png" alt="Schengen" />
              </div>
              <h3>Schengen Area</h3>
            </div>
          </div>
        </div>
      </section>

      {/* Main Enquiry Section */}
      <section className="visa-enquiry-section">
        <div className="visa-enquiry-container">
          
          {/* Left Side: Info */}
          <div className="visa-info-panel">
            <h2>Why Choose Our Visa Services?</h2>
            <ul className="visa-benefits">
              <li>
                <span className="benefit-icon">📋</span>
                <div>
                  <strong>End-to-End Documentation</strong>
                  <p>We review and prepare all your documents to minimize rejection chances.</p>
                </div>
              </li>
              <li>
                <span className="benefit-icon">⚡</span>
                <div>
                  <strong>Fast Processing</strong>
                  <p>Priority handling and quick appointment bookings for urgent travel.</p>
                </div>
              </li>
              <li>
                <span className="benefit-icon">🎯</span>
                <div>
                  <strong>High Approval Rate</strong>
                  <p>Expert mock interviews and profile strengthening for tricky visas.</p>
                </div>
              </li>
              <li>
                <span className="benefit-icon">🌍</span>
                <div>
                  <strong>Global Coverage</strong>
                  <p>Assistance for USA, UK, Schengen, Canada, Australia, Dubai & more.</p>
                </div>
              </li>
            </ul>
            
            <div className="visa-contact-direct">
              <p>Need urgent visa assistance? Call us directly:</p>
              <a href="tel:+919096785868" className="direct-phone">📞 +91 9096785868</a>
            </div>
          </div>

          {/* Right Side: Enquiry Form */}
          <div className="visa-form-panel">
            <h3>Visa Enquiry Form</h3>
            <p className="form-subtitle">Fill in your details and our visa expert will contact you with a customized checklist and quote.</p>

            <form className="visa-form" onSubmit={handleSubmit}>
              <div className="form-row">
                <div className="form-field">
                  <label>Full Name *</label>
                  <input
                    type="text"
                    name="name"
                    placeholder="John Doe"
                    value={form.name}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="form-field">
                  <label>Phone Number *</label>
                  <input
                    type="tel"
                    name="phone"
                    placeholder="+91 98765 43210"
                    value={form.phone}
                    onChange={handleChange}
                    required
                  />
                </div>
              </div>

              <div className="form-field">
                <label>Email Address</label>
                <input
                  type="email"
                  name="email"
                  placeholder="you@example.com"
                  value={form.email}
                  onChange={handleChange}
                />
              </div>

              <div className="form-row">
                <div className="form-field">
                  <label>Visa Type *</label>
                  <select name="visaType" value={form.visaType} onChange={handleChange} required>
                    <option value="Tourist Visa">Tourist Visa</option>
                    <option value="Business Visa">Business Visa</option>
                    <option value="Transit Visa">Transit Visa</option>
                    <option value="Family/Dependent Visa">Family/Dependent Visa</option>
                    <option value="Student Visa">Student Visa</option>
                    <option value="Work Visa">Work Visa</option>
                    <option value="Other">Other</option>
                  </select>
                </div>
                <div className="form-field">
                  <label>Destination Country *</label>
                  <input
                    type="text"
                    name="destinationCountry"
                    placeholder="e.g., USA, UK, Canada, Schengen"
                    value={form.destinationCountry}
                    onChange={handleChange}
                    required
                  />
                </div>
              </div>

              <div className="form-row">
                <div className="form-field">
                  <label>Approx. Travel Date</label>
                  <input
                    type="date"
                    name="travelDate"
                    value={form.travelDate}
                    onChange={handleChange}
                  />
                </div>
                <div className="form-field">
                  <label>Number of Applicants *</label>
                  <select name="applicants" value={form.applicants} onChange={handleChange} required>
                    <option value="1">1 Applicant</option>
                    <option value="2">2 Applicants</option>
                    <option value="3">3 Applicants</option>
                    <option value="4+">4+ (Family/Group)</option>
                  </select>
                </div>
              </div>

              <div className="form-field">
                <label>Special Requirements / Questions (Optional)</label>
                <textarea
                  name="message"
                  rows="4"
                  placeholder="e.g., Previous visa rejection, urgent travel, specific embassy queries..."
                  value={form.message}
                  onChange={handleChange}
                ></textarea>
              </div>

              {status === "success" && (
                <div className="form-status success">
                  ✅ Enquiry sent successfully! Our visa expert will contact you shortly.
                </div>
              )}
              {status === "error" && (
                <div className="form-status error">
                  ⚠️ Something went wrong. Please try again or WhatsApp us directly.
                </div>
              )}

              <button
                type="submit"
                className="submit-enquiry-btn"
                disabled={status === "sending"}
              >
                {status === "sending" ? (
                  <span className="btn-spinner"></span>
                ) : (
                  "Submit Visa Enquiry"
                )}
              </button>
            </form>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default VisaServices;